import React from 'react';
import type { ReportAchievement, ReportDetailLabels } from '../../../shared/types/reports';

export interface AchievementsProps {
  achievements: ReportAchievement[];
  labels: ReportDetailLabels;
}

export function Achievements({ achievements, labels }: AchievementsProps) {
  if (achievements.length === 0) {
    return null;
  }

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">
          <i className="bi bi-trophy me-2"></i>
          {labels.achievements}
        </h5>
      </div>
      <div className="card-body">
        <div className="row g-3">
          {achievements.map((achievement) => (
            <div key={achievement.id} className="col-6 col-md-4 col-lg-3">
              <div className="text-center p-3 rounded bg-light h-100">
                <div className="mb-2">
                  <span
                    className="achievement-icon fs-1"
                    role="img"
                    aria-label={achievement.name}
                  >
                    {achievement.icon}
                  </span>
                </div>
                <h6 className="fw-semibold mb-1">{achievement.name}</h6>
                <p className="text-muted small mb-0">{achievement.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Achievements;
